import React from "react";
import FormTextField from "./FormTextField";

/**
 * Ad / Soyad input atomu — rakam girilemez. FormTextField stilini korur.
 * @param {string} value
 * @param {(v: string) => void} onChange
 * @param {object} rest - FormTextField'a geçen diğer props (label, sx, fullWidth, ...)
 */
const stripDigits = (s) => (s || "").replace(/[0-9]/g, "");

export default function NameInput({ value, onChange, ...rest }) {
  return (
    <FormTextField
      value={value}
      onChange={(e) => onChange(stripDigits(e.target.value))}
      {...rest}
    />
  );
}
